module.exports = new __parcel__URL__("forest_born.f68b3408.mp3").toString();